import { Button, Typography, Paper, Grid, Tooltip } from "@material-ui/core";
import * as React from "react";
import { PortalAppBar } from "src/components/app-bar";
import { observable, computed } from "mobx";
import { authStore, checkAuthStore } from "../auth";
import {
  Redirect,
  Route,
  Switch,
  withRouter,
  BrowserRouter as Router,
  RouteComponentProps,
} from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core"; // E-048
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { UserPanel } from ".";
import trianglify from "src/resources/trianglify.png";
import { AppPanel } from "src/modules/apps";
import { UsersAdmin } from "src/modules/admin/modules/UsersAdmin";
import { UserAccount } from "src/modules/admin/modules/UsersAdmin/components";
import { UserAccountPassword } from "src/modules/admin/modules/UsersAdmin/components";
import { CompaniesAdmin } from "src/modules/admin/modules/CompaniesAdmin";
import { observer } from "mobx-react";
import * as _ from "lodash";
import SmallFooter from "src/components/footer/SmallFooter";
import { CompaniesAdminDetails } from '../admin/modules/CompaniesAdmin/components';
import { Permissions, permissionsStore } from '../admin/modules/Permissions';
import { UsersAdminDetails } from '../admin/modules/UsersAdmin/components';
import { PortalRoute } from '.';
import { PasswordVerify } from '.';
import ChangeUserPassword from '../admin/modules/UsersAdmin/components/ChangeUserPassword';
import { Dashboard } from '../dashboard';
import { Settings } from '../admin/modules/Settings';
import { config } from 'src/config';
import Support from '../support/Support';
import { AutoLogOut } from ".";
import { history } from "../../history.js"; //E-048.2 

const styles = createStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    height: "100vh",
    flexWrap: "nowrap",
  },
  body: {
    // width: "calc(100% - 3rem)",
    // height: "calc(100% - 3rem)",
    width: "100%",
    display: "flex",
    flexGrow: 1,
    padding: "1.5rem",
    margin: 0,
    backgroundImage: `url(${trianglify})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    flexDirection: "row-reverse",
  },
  paper: {
    flex: 1,
    border: "solid .5px #194b87",
    // display: "flex",
    overflow: "auto",
    marginBottom: '30px'
  },
  pageContainer: {
    height: "100%",
    padding: "1.5rem",
    overflowX: 'hidden'
  },
  mainContentContainer: {
    display: "flex",
    flex: "auto",
    maxHeight: "100%",
  },
  sideBarContainer: {
    // width: "18rem",
  }, //E-072
  div: {
    width: "30px",
    height: "2px",
    backgroundColor: "#000000",
    margin: "5px 0",
  },
});

@observer
class StyledPortal extends React.Component<
WithStyles<typeof styles> & RouteComponentProps
> {
  @observable
  public SessionKey: string | null;
  public dialogOpen: boolean = false; // B-036
  public errorStatus: string; // B-036
  //  E-048
  public timer;
  public events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
  ];
  public showModal: any = false;
  public logOutTime: any;
  public popupTimer: any;


  public state = {
    chatOpen: false,
    chatTooltipOpen: false,
    deleteDialogOpen: false,
    timeTimer: 30,
    isToggleBtn: false, //E-072
  }

  constructor(props: any) {
    super(props);
    this.SessionKey = localStorage.getItem("token");
  }

  public log = () => {
    console.log(this.props);
  };


  public receiveMessage = (event: any) => {
    if (event.data.fn === 'restoreWindow') {
      this.setState({ chatOpen: true, chatTooltipOpen: false })
    }
    else if (event.data.fn === 'minimizeWindow') {
      this.setState({ chatOpen: false })
    }
  }

  public handleChatTooltipOpen = () => {
    // const sendAction = () => {
    //   console.log('actions')
    //   const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
    //     input !== null && input.tagName === 'IFRAME';

    //   const iframeEl = document.getElementById("portal-frame");

    //   if (isIFrame(iframeEl) && iframeEl.contentWindow) {
    //     console.log('iframe')
    //     iframeEl.contentWindow.postMessage('action', '*')
    //   }
    // }

    if (this.state.chatOpen) {
      return

    }
    // sendAction()
    this.setState({ chatTooltipOpen: true })
  }

  public handleChatTooltipClosed = () => {
    this.setState({ chatTooltipOpen: false })
  }


    // E-048
    public handleLogoutTimer() {
      this.popupTimer = setTimeout(() => {
        Object.values(this.events).forEach(item => {
          window.removeEventListener(item, this.resetTimer);
        });
        this.setState({ deleteDialogOpen: true }); //E-048.2
        this.timer= setInterval(() => {
          if(this.state.timeTimer==0){
            clearTimeout(this.popupTimer);
            this.handleLogout();
            this.resetTimer();
          }
          this.setState({ timeTimer: this.state.timeTimer - 1 });
        }, 1000);
      }, this.logOutTime * 60 * 1000 - 30000); // 30000ms = 30secs
      // Set the timer for the actual logout action
      // this.timer = setTimeout(() => {
         //   this.handleLogout();
      // }, this.logOutTime * 60 * 1000); // 10000ms = 10secs. You can change the time. set for 5 min 300000 // 300000ms (5 minutes) // Convert minutes to milliseconds
    }
  
    public handleLogout = async () => {
      this.setState({ deleteDialogOpen: false, timeTimer: 30 }); //E-048.2
      await authStore.logout(authStore.currentUser.auth_id);
      history.push("/");
    };
    resetTimer() {
      if (this.timer) clearTimeout(this.timer);
      if (this.popupTimer) clearTimeout(this.popupTimer); // clear the popup timer
    }
  
    public getDeleteDialog = (active: boolean) => {
      return (
        <Dialog
          open={active}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          // tslint:disable-next-line: jsx-no-lambda
          onBackdropClick={() => this.setState({ deleteDialogOpen: false })}
        >
          <DialogTitle></DialogTitle>
                  
          <DialogContent>          
            <div className="" style={{ maxWidth: "65vw", fontFamily: "sans-serif"  }}>
              Your session has expired!
              <div style={{ marginTop: 20,display: "flex" }}>
                For your security, Your session is about to expire! in
                <span
                  style={{
                    color: "#FF0000",
                    fontWeight: 800,
                    marginLeft: 5,
                    marginRight: 5,
                    marginTop: -3
                  }}
                >
                  {`00:${this.state.timeTimer}`}
                </span>
                due to inactivity.
              </div>
             <p> If you continue, the system will not sign out
                immediately.</p>
            </div>
            
          </DialogContent>
          <div
            style={{
    
              marginBottom: "2rem",
              paddingBlock: "1rem",
            }}
          ></div>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => this.handleStayLoggedIn()}
              color="primary"
            >
              Continue
            </Button>
            <Button
              variant="contained"
         
              onClick={() => this.handleLogout()}
              color="primary"
              autoFocus={true}
            >
              Log Out
            </Button>
          </DialogActions>
        </Dialog>
      );
    };
  
    async componentDidMount() {
      let getResponse = localStorage.getItem("userdata");
      this.logOutTime = Number(getResponse);
      Object.values(this.events).forEach(item => {
        window.addEventListener(item, () => {
          if (authStore.currentUser.portal_role_id != 1) {
            if (
              permissionsStore?.checkPermissionByCategoryAndType("user", "logout")
            ) {
              this.resetTimer();
              this.handleLogoutTimer();
            }
          }
        });
      });
    }
    handleStayLoggedIn = () => {
      this.resetTimer();
      this.setState({ deleteDialogOpen: false, timeTimer: 30 }); //E-048.2
    };
    public logoutAction = () => {
      if (authStore.currentUser.portal_role_id != 1) {
        if (permissionsStore?.checkPermissionByCategoryAndType("user", "logout")) {
          this.showModal = true;
          localStorage.clear();
          window.location.pathname = "/"; // Home page
        }
        return null;
      }
      return null;
    };

  //E-072
  public handleToggleChange = () => {
    if (this.state.isToggleBtn === true) {
      this.setState({ isToggleBtn: false });
    } else {
      this.setState({ isToggleBtn: true });
    }
  };
  
  // B-036 Changed the static code
  public redirectFun = async () => {
    await history.push(`/admin/users/edit/${authStore?.currentUser.auth_id}`); 
  }

  public render() {
    const { classes, location } = this.props;
    // E-048
    const deleteDialog = this.getDeleteDialog(this.state.deleteDialogOpen);   
    const isPathActive = window.location.pathname === `/admin/users/edit/${authStore?.currentUser.auth_id}`;
    // B-036 *************************
    if (authStore?.currentUser?.Phone?.length === 0) {
      this.dialogOpen = true
      this.errorStatus = "Please update your Phone number"
    } else if (authStore?.currentUser?.FirstName?.length === 0) {
      this.dialogOpen = true
      this.errorStatus = "Please update your First name"
    } else if (authStore?.currentUser?.LastName?.length === 0) {
      this.dialogOpen = true
      this.errorStatus = "Please update your Last name"
    } else if (this.props.location.pathname === `/admin/users/edit/${authStore?.currentUser.auth_id}`) {
      this.dialogOpen = false
    }
    // B-036 *************************



    window.addEventListener("message", this.receiveMessage, true);

    const chatdiv = (prop: unknown) => {
      if (prop) {
        return (
          <div style={{ width: '100%', height: '100%' }}>
            <iframe
              id="portal-frame"
              className="portal-frame"
              frameBorder="0"
              src={config.BASE_CHAT_URL + '/' + authStore.currentUser.SessionKey}
              width={'100%'}
              height={'100%'}
            />
          </div>
        )
      }
      return null
    }

    let isChrome = !!(window as any).chrome && (!!(window as any).chrome.webstore || !!(window as any).chrome.runtime);

    let mobile = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      mobile = true;
      isChrome = true;
    }


    if (!isChrome && config.ONLY_ALLOW_CHROME) {
      return <div style={{
        margin: 'auto',
        width: '50%',
        textAlign: 'center',
        marginTop: '100px',
        border: '2px solid darkblue',
        padding: '10px'
      }} >
        <div>Browser incompatible, please use Chrome</div>
        <div><a href="https://www.google.com/chrome/">Download Chrome Here</a></div></div>
    }

    return (
      <>
      {deleteDialog}
      {/* // B-036 ************************* */}
      {!isPathActive ?
        <Dialog
          open={this.dialogOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle>{this.errorStatus}</DialogTitle>
          <DialogActions>
            <Button
              variant="contained"
              onClick={this.redirectFun}
              color="primary"
              autoFocus={true}
            >
              Update here
            </Button>
          </DialogActions>
        </Dialog> : false
      }
       {/* // B-036 ************************* */}
      <Grid container={true} className={classes.root}>
      {/* E-072 */}
      <div style={{display :'flex', justifyContent:'space-between',  backgroundColor: 'white', 
                        boxShadow:'0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)'}}
              >
              <Button onClick={this.handleToggleChange}>
              <div>
              <div className={this.props.classes.div}></div>
              <div className={this.props.classes.div}></div>
              <div className={this.props.classes.div}></div>
              </div>
              </Button>
              <div >
              <PortalAppBar className={classes.sideBarContainer}/>
              </div>
              </div>
              {/* E-072 */}
        <Grid container={true} spacing={40} style={{ height: '100%' }}>
          <Grid item={true} xs={2} style={{ display: this.state.isToggleBtn === true ? "none" : "" }}> 
            <Paper className={classes.paper}>
              <UserPanel />
            </Paper>
          </Grid>
          {/* C-071, E-072 Grid */}
          <Grid 
          item={true} 
          xs={10} className={classes.mainContentContainer} 
          style={{
            paddingRight: "50px",
            maxWidth: this.state.isToggleBtn === true ? "none" : "",
            paddingLeft : this.state.isToggleBtn === true ? "50px" : "",
          }}
          > 
            <Paper className={classes.paper}>
              <Switch>
                <PortalRoute path={"/admin/users/edit/password/:id(\\d+)"} component={ChangeUserPassword} permission={{ PermissionCategory: 'user', PermissionType: 'update' }} />
                <PortalRoute path={"/admin/users/:view_type/:id(\\d+)"} component={UsersAdminDetails} permission={{ PermissionCategory: 'user', PermissionType: 'read' }} />
                <PortalRoute path={"/admin/users/:view_type"} component={UsersAdminDetails} permission={{ PermissionCategory: 'user', PermissionType: 'read' }} />
                <PortalRoute path="/admin/users" component={UsersAdmin} permission={{ PermissionCategory: 'user', PermissionType: 'read' }} />

                <PortalRoute path={"/admin/companies/:view_type/:id(\\d+)"} component={CompaniesAdminDetails} permission={{ PermissionCategory: 'company', PermissionType: 'read' }} />
                <PortalRoute path={"/admin/companies/:view_type"} component={CompaniesAdminDetails} permission={{ PermissionCategory: 'company', PermissionType: 'read' }} />
                <PortalRoute path="/admin/companies" component={CompaniesAdmin} permission={{ PermissionCategory: 'company', PermissionType: 'read' }} />

                <PortalRoute path="/admin/permissions" component={Permissions} permission={{ PermissionCategory: 'permission', PermissionType: 'read' }} />
                <PortalRoute path="/admin/settings" component={Settings} permission={{ PermissionCategory: 'settings', PermissionType: 'read' }} />

                <PortalRoute path="/support" component={Support} permission={{ PermissionCategory: 'support', PermissionType: 'read' }} />

                <PortalRoute path="/dashboard" component={Dashboard} permission={{ PermissionCategory: 'dashboard', PermissionType: 'read' }} />
                <PortalRoute path={"/account/password/:id(\\d+)"} component={UserAccountPassword} permission={{ PermissionCategory: 'dashboard', PermissionType: 'read' }} />
                <PortalRoute path="/account" component={UserAccount} permission={{ PermissionCategory: 'dashboard', PermissionType: 'read' }} />
                <PortalRoute path="/password-verify" component={PasswordVerify} />
                <PortalRoute path="/autoLogOut"component={AutoLogOut} /> 
                <PortalRoute path="/" component={Dashboard} permission={{ PermissionCategory: 'dashboard', PermissionType: 'read' }} />
              </Switch>
            </Paper>
          </Grid>
        </Grid>
        {/* tslint:disable-next-line: jsx-no-lambda */}
        <Tooltip
          title={'Live Support'}
          placement={'left'}
          open={this.state.chatTooltipOpen}
          onOpen={this.handleChatTooltipOpen}
          onClose={this.handleChatTooltipClosed}
        >
          <div id="chat-container" style={{ position: 'absolute', right: 0, bottom: 0, height: this.state.chatOpen ? '500px' : '100px', width: this.state.chatOpen ? '500px' : '100px', zIndex: 1 }} >
            {chatdiv(authStore.loaded)}
          </div>
        </Tooltip>

      </Grid>
      </>
    );
  }
}

export const Portal = withStyles(styles, { withTheme: true })(StyledPortal);


// WEBPACK FOOTER //
// ./src/modules/portal/Portal.tsx